import {$q1, } from "../ui-scripts/dom-helpers";

function backToTop () {

	const bttBtn = $q1('.js-site-btt');

	if (bttBtn != null) {
		bttBtn.addEventListener('click', ()=> {
			window.scroll({
				top : 0,
				behavior: "smooth",
			})
		})
	}

}

export {backToTop};
